/**
 * 中文
 */
const lang = {
	lang: { //语言切换
		langlist: [{
			type: "Chinese",
			name: "简体中文",
			langimg: "../assets/image/kf.png"
		},
		{
			type: "English",
			name: "英语",
			langimg: "../assets/zg.png"
		},
		{
			type: "Traditional",
			name: "繁体中文",
			langimg: "../assets/zg.png"
		},
		{
			type: "Japanese",
			name: "日语",
			langimg: "../assets/zg.png"
		},
		{
			type: "Vietnamese",
			name: "越南语",
			langimg: "../assets/zg.png"
		},
		{
			type: "Malay",
			name: "马来语",
			langimg: "../assets/zg.png"
		},
		{
			type: "Hindi",
			name: "印度语",
			langimg: "../assets/zg.png"
		},
		{
			type: "Thai",
			name: "泰语",
			langimg: "../assets/zg.png"
		},
		{
			type: "Russian",
			name: "俄语",
			langimg: "../assets/zg.png"
		},
		{
			type: "Indonesian",
			name: "印尼语",
			langimg: "../assets/zg.png"
		}
		],
		langtype: "zh-CN",
		langimg: "../assets/zg.png"
	},
	announcement: {
		title: '最新公告',
		close: '关闭',
	},
	tabbar: { //底部
		index: "首页",
		activity: "活动",
		to_promote: "推广",
		help: "帮助",
		my: "我的"
	},
	// 提示
	prompt: {
		verification: "验证码错误",
		account: "账号6-20位纯数字或字母",
		password: "密码大于等于6位数字+字母或字符组合",
		two: "两次密码不一致",
		yizhi: '密码和账号不能相同',
		successful: "注册成功",
		loginsuccessful: "登录成功",
		null: "账号密码不能为空",
		Binding: "绑定成功",
		buzhengque: '地址格式不正确',
		address: "请填写地址",
		Please_choose: "请先选择一项并输入下注金额",
		Bet_type: "请先选择下注类型",
		success: "下注成功",
		complete_password: "请输入完整的密码",
		copy_success: "已复制到剪切板",
		copy_fail: "复制失败",
		Set_success: "设置成功",
		Set_password: "请设置6位数密码，不能包含“字母、符合、空格”",
		update_success: "修改成功",
		input_number: "请输入数量",
		addressvalue: "请选择钱包地址"
	},
	head: { //头部
		luckyhash: "哈希押注",
		address: "绑定钱包地址",
		history: "投注历史",
		help: "帮助",
		lotteryRecord: "开奖记录",
		notice: "公告列表",
		question: "常见问题",
		performance: "我的团队",
		add_address: "添加钱包",
		asset: "资产密码",
		balance: "余额明细",
		exchangeRecord: "兑换",
		forrecord: "兑换记录",
		language: "语言设置",
		update_assets_password: "修改资产密码",
		update_login_password: "修改登录密码",

		myteam: "查看明细",
		recharge: "钱包充值",
		setting: "设置",
		transactiondetails: "投注记录",
		transfer: "佣金转移",
		user: "个人中心",
		userInfo: "个人资料",
		withdrawal: "提现",
		commission: "佣金提现",
		withdrawalRecord: "提现记录",
		top_up: "充值记录"
	},
	withdrawalRecord: {
		Select_month: "选择月",
		afterPrice: "余额",

	},
	withdrawal: {
		withdrawalrecord: "提现记录",
		commission: "可提现资产",
		number: "转移数量",
		withdrawal_number: "提现数量",
		money_address: "钱包地址",
		addressvalue: "请选择收款钱包地址",
		poundage: "手续费",
		immediately: "立即提现",
		Warm_prompt: "温馨提示",
		input_password: '请输入资产密码',
		betting: "投注",

	},
	userInfo: {
		Head_portrait: "个人头像",
		account: "账号",
		Choose_picture: "选择头像",
		cancel: "取消",
		determine: "确定"
	},
	user: {
		wallet_account: "钱包账户",
		balance: "余额明细",
		top_up: "充值",
		withdrawal: "提现",
		my_wallet: "我的钱包",
		add_wallet: "添加钱包",
		look: "查看记录",
		look_all: "查看更多",
		Pack_up: "收起",
		For_record: "兑换记录",
		bettingRecord: "交易明细",
		reward: "推广奖励",
		goCustomerLink: "在线客服",
		Commission_account: "佣金账户",
		transfer: "转移",
		number: "投注数据",
		transactiondetails: "查看明细",
		day: "今日投注",
		day_winning: "今日中奖",
		my_team: "我的团队",
		about_we: "关于我们",
		center: "客服中心",
		setting: "设置",
		delete: '删除',
		isDelete: "确认删除钱包"
	},
	transfer: {
		money: "佣金余额",
		account_balance: "账户余额",
		number: "转移数量",
		select: "请选择",
		Immediately_transfer: "立即转移",
		password: "请输入资产密码",
		betting: "投注",

	},
	transactiondetails: {
		type: "类型",
		input_type: "请选择类型",
		date: "日期",
		select_date: "请选择日期",
		select: "查询",
		bettingmoney: "投注金额",
		winning_amount: "中奖金额",
		time: "时间",
		not: "没有数据",
		noopen: '暂未开放',
		B1: '区块链游戏-幸运大小',
		B2: '区块链游戏-幸运组合',
		B3: '区块链游戏-幸运龙虎',
		B4: '区块链游戏-幸运庄闲',
		B5: '区块链游戏-幸运数字',
		A1: '娱乐城-幸运赛车',
		A2: '娱乐城-幸运快艇',
		A3: '娱乐城-幸运赛马',
		A4: '娱乐城-幸运大小',
		A5: '娱乐城-幸运组合',
		A6: '娱乐城-幸运龙虎',
		A7: '娱乐城-幸运庄闲',
		A8: '娱乐城-幸运数字',
		options: [{
			value: "幸运哈希-双面",
			label: "B1",
		},
		{
			value: "幸运哈希-组合",
			label: "B2",
		},
		{
			value: "幸运哈希-龙虎合",
			label: "B3",
		},
		{
			value: "幸运哈希-百家乐",
			label: "B4",
		},
		{
			value: "幸运哈希-独胆",
			label: "B5",
		},
		],
	},
	setting: {
		phone: '绑定手机号',
		updatepwd: "修改登录密码",
		assets_pwd: "资产密码",
		not: "未设置",
		yes: "已设置",
		language: "语言设置",
		exit: "退出",

	},
	recharge: {
		recharge_code: "充值记录",
		Chain_type: "链类型",
		address: "充值地址",
		copy_address: "复制地址",
		remind: "操作提醒",
		content: "内容内容内容内容内容内容内容",
		copy_success: '复制成功'
	},
	myteam: {
		select: "查询",
		time: "日期",
		money: "当日佣金",
		people: "直属人数",
		team: "团队",
		zsxx: "请输入UID可查看直属玩家信息",
		zsyj: '直属业绩',
		tdyj: '团队业绩',
		jryj: '今日业绩',
		jrsy: '今日收益',
		ljsy: '累计收益',
		friendsCategoryList: ['一级', '二级', '三级', '四级', '五级'],
	},
	login: {
		order_password: "旧密码",
		input_ordpwd: "请输入旧密码",
		new_pwd: "新密码",
		number: "请设置6-16位大小写字母+数字",
		six_pwd: "请输入6位数字密码",
		confirmPassword: "确认密码",
		confirm: "确认",
	},
	forrecord: {
		spending: "兑换支出",
	},
	exchangeRecord: {
		exchangeRecord: "兑换",
		record: "记录",
		For_spending: "兑换支出",
		money: "兑换金额",
		exchange_number: "兑换数量",
		number: "数量",
		market_price: "行情价",
		Miners_fee: "矿工费",
		input_money: "请输入兑换金额",
		Get_the_amount: "获得金额",
		Can_be: "可获得金额",
		address: "钱包地址",
		Immediatelychange: "立即兑换",
		Warm_prompt: "温馨提示",
		details: "详情详情详情详情详情详情详情详情详情详情详详情详情详情详情详情详情详情详情详情详情详情详情详情情详详情详情详情详情详情详情详情详情详情详情详情详情详情情详"
	},
	balance: {
		balance_of: "余额",
		data: "日期",
		dataPickerRange: "请选择",
		select: "查询",
		to: '至'
	},
	asset: {
		password: "请设置6位数密码，不能包含“字母、符合、空格”",
		confirm: "确认",
	},
	add_address: {
		money_address: "请输入钱包地址（TRC20）",
		save: "保存"
	},
	spread: {
		cumulative: "您累计邀请",
		people: "人",
		make: "已赚到",
		Continue_to: "继续努力冲击大奖",
		url: "分享链接",
		Friends_registered: "好友注册",
		money: "绑定钱包",
		Friends_deal: "好友交易",
		copy_url: "复制分享链接",
		my_group: "我的团队",
		look: "业绩详情",
		directCount: "直属",
		group: "团队",
		Commission_withdrawal: "收益提现",
		historyAward: "累计收益",
		yesterdayAward: "昨日收益",
		currentAward: "收益余额",
		todayAward: "今日业绩",
		my_invite: "我的邀请码",
		copy_invite: "点击复制",
		top_title: "我的上级",
		update: "绑定后无法修改",
		nikname: "请输入上级邀请码",
		binding: "绑定",
		Commission_ratio: "佣金比例",
		level: "级别",
		ratio: "返佣比例（投注额）",
		Directly_under: "直属下级",
		first: "第",
		levelone: "级",

	},
	performance: {
		datatime: "日期",
		pick: "请选择",
		select: "查询",
		total: "今日总业绩",
		performance: "查看明细",
		directCount: "直属下级",
		todayTotalPerformByDirect: "直属业绩",
		other: "其他下级",
		todayTotalPerformByOther: "其他业绩",
		Commission_withdrawal: "佣金提现",
		historyAward: "累计收益",
		yesterdayAward: "昨日收益",
		currentAward: "收益余额",
		todayAward: "今日业绩",
		Commission_ratio: "佣金比例",
		level: "级别",
		ratio: "返佣比例（投注额）",
		Directly_under: "直属下级",
		first: "第",
		levelone: "级",
	},
	lotteryRecord: { //开奖记录
		block: "区块",
		highly: "区块高度",
		results_of: "结果",

	},
	help: {
		DAPP: "参与流程",
		a: "复制DAPP游戏地址进行USDT-TRC20转账",
		b: "在钱包区块链浏览器（TRX网络）中打开本网站，即可对DAPP进行立即投注，无需复制",
		Focus_on: "请经常关注刷新我们的主页，获得最新交易地址。",
		login: "登录波场官网查询区块哈希值",
		hash: "您可在波场官网查询您的区块哈希值",
		you: "您可在波场官网",
		login_website: "登录波场官网",
		query: "上查询您的区块哈希值",
		look: "点击查看教程",
		congratulations: "恭喜您",
		winning: "若中奖，系统将在1分钟内返奖到您",
		address: "若中奖，系统将在1分钟内返奖到您的转账地址中到您的转账地址中",
		number: "数字币交易所中购买USDT和TRX",
		skip: "若您的钱包已有USDT和TRX，可跳过此步骤",
		Digital_currency: "在数字币交易所中购买USDT和TRX，然后将USDT和TRX转入您的[去中心化钱包]，您可以使用以下去中心化钱包网站注册的钱包：",
		platform: "平台",
		url: "网址",
		tutorial: "教程",
		vpn: "友情提示：若无法打开Telegram，可以使用神VPN",
		vpnurl: "神灯VPN网址",
		whirlwind: "旋风加速器网址",
		can_login: "即可登录",
		why: "为什么选择xxxx",
		most_fair: "最公平",
		play: "不踢人、不掉线、不受任何干扰",
		Publicly_available: "区块哈希值随机生成，结果统一，无法更改，公开可查",
		security: "最安全",
		no_money: "运营资金可见，不用担心没钱返奖",
		Cannot: "所有人转账记录可见，无法虚假宣传",
		Visi_convenient: "最便捷",
		Without_registration: "无需注册，无需预充值，无需申请提款",
		questions: "常见问题",
		one: "什么是【区块哈希值】（Block Hash）",
		dna: "区块哈希值是一段数据的DNA，每个区块哈希值都是唯一的、随机的且不可破解的。",
		lookintroduce: "点击查看百度百科哈希值介绍。",
		what: "什么区块链",
		Block_chain: "区块链从本质上讲，它是一个共享数据库，存储于其中的数据或信息。具有不可伪造、全程留痕、可以追溯、公开透明、集体维护等特征。",
		wallet: "中心化钱包？去中心化钱包？为什么中心化钱包无法查询转账？",
		example: "例如：您自己的钱包地址是A,您给地址E转入10USDT,但您用交易哈希值去查询，只能查询到服务商随机某个账本地址B(或C或D等等)与E的转账。同理E也无法得知这10个USDT是否是您转出的，因为E只能看见是账本地址B给他转入10个USDT。这就是为什么中心化钱包无法在区块鞋上查询真实转账信息。",
		why_winning: "为什么我会连续中奖或不中奖",
		First: "首先连续多次不中奖的是小概率事件",
		small: "小概率事件定义",
		second: "其次中奖与不中奖是随机事件， 随机事件的发生的频率会趋于一个稳定值。在非迭代的情况下，事物出现的概率对每个人来讲是相等的，这个情况下，每个人都是公平的。同时随机事件会遵大数定律（在试验不变的条件下，重复试验多次，随机事件的频率近似于它的概率大数定律定义)，在转账频次不断增加的情况下，中奖与不中奖的概率会趋于一—个稳定值。所以请您继续转账，随着转账频次增加则中奖总概率会提升。",
		whydelay: "为什么会延迟到账",
		Click_to_view: "点击查看区块链的速度因境： 《贵在信任，慢得其所》",
		six: "为什转币时有钥那么务USDT的类型选项？我该选哪一个？",
		global: " 全球有许多知名公链",
		click_look: "点击查看全球知格公链简介",
		how: "转币时转带地址或选错币的类型，怎么办？是否还 能回？",
		For_instance: " 比如说您给我们转币时应该选择USD下TRC20型，但您选择了其他类型USD下OMNI或者USDERC20，那么就会出现丢币的情况，这种情况是无法找回的。",
		How_to_force: "点击查看如果转错币怎么办？",
		Other_problems: "其他问题",
		callwe: "如有任何疑问请联系我们",
		immediately: "立即投注",
		company: "公司信息",
		link: "友情链接",
		register: "注册数字币去中心化钱包",
		Already_have: "若您有已拥有钱包，可跳过此步骤",
		download: "下载并注册一个数字币去中心化钱包",
		com_title: "数字币钱包相关网站教程如下"
	},
	register: { //登录注册
		login_tips: "请重新设置您的登录密码",
		address: "请输入钱包地址",
		confirm: "确认密码",
		confirmupdate: "确认修改",
		toRegister: "注册",
		agreement: "登录即同意",
		user: "用户协议",
		policy: "隐私政策",
		welcome: "欢迎来到",
		login1: "登录您的账号",
		forget: "忘记密码?",
		nowLogin: "登入",
		nologin: "暂不登录",
		new: "创建一个新账户",
		login: "让您赚钱更轻松",
		account: "账号6-20位纯数字或字母",
		password: "密码大于等于6位数字+字母或字符组合",
		confirm_password: "确认密码",
		inviteCode: "请输入邀请码(选填)",
		verificationCode: "请输入验证码",
		toRegister: "注册",
		noaccount: "没有账号",
		toLogin: "去登录"
	},
	address: {
		warmprompt: "温馨提示：请填写正确的钱包地址，否则无法取款，取款钱包地址一经填写绑定无法修改，如需修改请联系客服",
		tips: "请至少绑定一个钱包地址，忘记密码时无法找回",
		TRC20: "为避免输入错误，请复制后长按此处粘贴（TRC20）",
		toBind: "立即绑定",
		noBind: "暂不绑定",
	},
	luckyhash: { //幸运哈希
		walletName: '链接钱包',
		exchange: "兑换",
		reward: "奖励",
		Customerservice: "客服",
		instructions: "说明",
		luckyhash: "区块链游戏",
		entertainment: "娱乐城",
		Doublesided: "幸运大小",
		odds: "赔率",
		immediately: "立即投注",
		combination: "幸运组合",
		LongHuge: "幸运龙虎",
		baccarat: "幸运庄闲",
		gallbladder: "幸运数字",
		Hashracingcar: "幸运赛车",
		Hashspeedboat: "幸运快艇",
		Hashracing: "幸运赛马",
		bothsides: "幸运数字",
		problem: "常见问题",
		all: "查看更多",
		friend: "合作伙伴"
	},
	history: {
		block: "区块",
		type: "类型",
		big: "大",
		highly: "区块高度",
		results_of: "结果"
	},
	entertainment: {
		lastBlock: "上期区块",
		resultValue: "等待开奖",
		currentblock: "当前区块",
		nextBlock: "本次开奖区块",
		toLotteryRecord: "开奖记录",
		block: "投注区块",
		money1: "投注金额",
		type: "类型",
		all: "查看更多",
		both_sides: "两面",
		big: "大",
		small: "小",
		single: "单",
		double: "双",
		daxiao: '大小',
		champion: "冠军",
		yajun: '亚军',
		he: '和',
		champion_one_size: "冠军单码",
		crown: "冠亚和",
		andbig: "和大",
		andsmall: "和小",
		andsingle: "和单",
		anddouble: "和双",
		championtwo: "冠军两面",
		combination: "组合",
		forlarge: "大单",
		smallsingle: "小单",
		large_double: "大双",
		small_double: "小双",
		Long_Huge: "龙虎和",
		dragon: "龙",
		tiger: "虎",
		us: "和",
		baccarat: "百家乐",
		zhuang: "庄",
		idle: "闲",
		gallbladder: "幸运数",
		Atotalof: "共",
		note: "注",
		Check_the_details: "查看详情",
		money: "钱包余额",
		pause: "机选",
		reset: "重置",
		inputmoney: "请输入金额",
		submit: "提交",
		password: "请输入交易密码",
		betting: "投注",
		determine: "确定",
	},
	details: {
		block: "区块",
		money: "金额",
		type: "类型",
		resultValue: "开奖结果",
		all: "查看更多",
		address: "投注地址",
		toLotteryRecord: "开奖记录",
		money: "钱包投注",
		copy: "复制投注地址",
		ts: "请勿使用交易所地址，否则无法收到返奖",
		USDT: "请转账波场USDT/TRX（Trc20）",
		Betting_amount: "投注金额",
		inputmoney: "请输入投注金额",
		confirm: "确认",
		cancel: "取消",
	},
	data: {
		noData: '暂无数据',
		deleteSuc: '删除成功',
		iscon: '确认投注？',
		fenpan: '封盘中,期间不可进行下注',
		erweima: '保存二维码'
	},
	phone: {
		title: '绑定手机号',
		phone: '手机号',
		input: '请输入绑定的手机号',
		code: '验证码',
		inputcode: "请输入验证码",
		getCode: '获取验证码',
		details: '请先填写区号、手机号',
		success: '验证码发送成功',
		bsuccess: '绑定成功',
		jiaoyi: '请先设置交易密码',
		caozuo: "操作成功",
		touxiang: "请选择一个头像",
		buzu: '余额不足',
		tuiguan: '推广中心',
		qubie: '点击查看区块链钱包区别',
		yhm: '请输入您的用户名',
		mm: '请输入您的密码',
		xqgg: '先去逛逛',
		llwm: '联系我们',
		lj: '请先连接钱包',
		dk: '请在钱包APP中打开',
		qd: '期待您的加入',
		yjmx: '佣金明细',
		pc: '派彩'
	},
	vip: {
		jl: "奖励",
		xrjl: '新人奖励',
		ckgz: '查看规则',
		zcsj: '注册送金',
		qbsj: '绑定手机跟钱包地址',
		dlq: '待领取',
		qwc: '去完成',
		ylq: '已领取',
		tgrw: '推广任务',
		rwjl: '任务奖励',
		yq: '邀请',
		ghy: '个优质好友',
		lqcg: '领取成功',
		bz: "请输入充值币种",
		je: '请输入充值金额',
		xyb: '下一步',
		czpz: '请上传充值凭证',
		zzhx: '请输入转账哈希',
		ljtj: '立即提交'
	}

}
export default lang



// WEBPACK FOOTER //
// ./src/i18n/language/Chinese.js